import React, { useEffect, useState } from 'react';
import { trackEvent, EVENT_TYPE_PAGE, trackGA4Event } from '../utils/trackEvent.jsx';
import CookieConsent from './CookieConsent.jsx';
import MultiStepForm from './carousel/MultiStepForm.jsx';
import FinanceProducts from '../components/FinanceProducts.jsx';
import OurPartners from '../components/OurPartners.jsx';
import { getApiUrl } from '../config/api.config.jsx';

// Add partner logos object
const partnerLogos = {
  distinguished: [
    { 
      name: 'CRAFT3', 
      logo: '/craft-3.png', 
      url: 'https://www.craft3.org/',
      description: 'Nonprofit Community Development Financial Institution (CDFI)'
    },
    { 
      name: 'TruDBooks', 
      logo: '/TruDBooks-logo.png', 
      url: 'https://trudbooks.org/',
      description: 'Accounting, Tax and Assurance services'
    },
  ],
  goldStar: [
/*    { 
      name: 'Stearns Bank', 
      logo: '/strns25-logo.svg', 
      url: 'https://www.stearnsbank.com/',
      description: 'National Financial Institution'
    }*/
  ],
  silverStar: [
  ],
};

// Add service providers array at the top with partner logos
const serviceProviders = [{
  name: 'Service Provider 1',
  logo: '/craft-3.png',
  url: 'https://example.com'
}/*,
{
  name: 'Service Provider 2',
  logo:  '/strns25-logo.svg', 
  url: 'https://example.com'
}*/
];

// Hero section text constants for consistency
const HERO_CONTENT = {
  title: "Halal funding to fuel your business",
  description: "Discover. Compare. Secure Halal Funding for your business with riba-free capital providers through our platform. Scale your business using Islamic Financing with confidence and peace of mind.",
  buttonText: "Find Halal Funding"
};

// Add testimonials array at the top
const testimonials = [
  {
    quote: "Business operations is such a huge component of scaling up a company, and HalalCred's vision for where Islamic financing can create leverage there is spot on. Their platform has helped us streamline the most toilsome parts of keeping our business riba-free.",
    author: "Mufti Ibrahim Essa",
    title: "CEO @ Alhamd Sharia Advisory Services",
    image: "/MuftiIbrahimEssa.webp"
  }
];

// Newsletter Signup Component
const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle', 'loading', 'success', 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setStatus('loading');
    
    // Track newsletter signup attempt
    trackGA4Event('newsletter_signup_attempted', {
      email_domain: email.split('@')[1] || 'unknown',
      signup_location: 'homepage_newsletter_section'
    });
    
    try {
      const response = await fetch(`${getApiUrl()}/newsletter/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setStatus('success');
        setEmail('');
        
        // Track successful newsletter signup
        trackGA4Event('newsletter_signup_success', {
          email_domain: email.split('@')[1] || 'unknown',
          signup_location: 'homepage_newsletter_section'
        });
        
        // Reset success message after 5 seconds
        setTimeout(() => setStatus('idle'), 5000);
      } else {
        setStatus('error');
        
        // Track failed newsletter signup
        trackGA4Event('newsletter_signup_failed', {
          email_domain: email.split('@')[1] || 'unknown',
          signup_location: 'homepage_newsletter_section',
          error_reason: 'api_error'
        });
        
        // Reset error message after 5 seconds
        setTimeout(() => setStatus('idle'), 5000);
      }
    } catch (error) {
      setStatus('error');
      
      // Track newsletter signup error
      trackGA4Event('newsletter_signup_failed', {
        email_domain: email.split('@')[1] || 'unknown',
        signup_location: 'homepage_newsletter_section',
        error_reason: 'network_error'
      });
      
      // Reset error message after 5 seconds
      setTimeout(() => setStatus('idle'), 5000);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email address"
          className="flex-1 px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#1a4a1a]/20 focus:border-[#1a4a1a] outline-none transition-all duration-200 text-slate-700 placeholder-slate-400"
          required
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className="inline-flex items-center justify-center px-6 py-3 bg-[#1a4a1a] text-white font-semibold rounded-lg shadow-md hover:bg-[#1a4a1a]/90 hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {status === 'loading' ? (
            <>
              <svg className="w-5 h-5 mr-2 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Subscribing...
            </>
          ) : (
            'Subscribe'
          )}
        </button>
      </div>
      
      {status === 'success' && (
        <div className="flex items-center justify-center text-green-600 text-sm font-medium">
          <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          Thank you! You've been subscribed to our newsletter.
        </div>
      )}
      
      {status === 'error' && (
        <div className="flex items-center justify-center text-red-600 text-sm font-medium">
          <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Something went wrong. Please try again.
        </div>
      )}
      
      <p className="text-xs text-slate-500 text-center">
        We respect your privacy. Unsubscribe at any time.
      </p>
    </form>
  );
};

const Home = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    trackEvent(EVENT_TYPE_PAGE);

    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    // Track CTA click in GA4
    trackGA4Event('find_halal_loans_clicked', {
      button_location: 'homepage_hero',
      button_text: 'Find Halal Funding'
    });
    
    const formElement = document.getElementById('loan-form');
    if (formElement) {
      const formPosition = formElement.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: formPosition - 20, // Subtracting 20px for some padding from the top
        behavior: 'smooth'
      });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    const slideInterval = setInterval(handleNextSlide, 5000); // Auto-advance every 5 seconds
    return () => clearInterval(slideInterval);
  }, []);

  return (
    <div className="min-h-screen">
      <section className="relative overflow-hidden min-h-screen">
        {/* Mobile Layout - Elegant Gradient Overlay */}
        <div 
          className="md:hidden relative min-h-screen overflow-hidden rounded-2xl"
          style={{ 
            marginLeft: '0.5rem',
            marginRight: '0.5rem'
          }}
        >
          {/* Full Background Image with Brightness Enhancement */}
          <div 
            className="absolute inset-0 z-0 brightness-110 contrast-105"
            style={{ 
              backgroundImage: `url("/uploads/hero-finance.jpg")`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />
          
          {/* Vibrant Gradient Overlay - Lighter and More Dynamic */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/40" />
          
          {/* Subtle Green Accent Overlay for Brand Consistency */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#1a4a1a]/10 via-transparent to-[#2d6a2d]/15" />
          
          {/* Text Content Overlay */}
          <div className="container relative z-10 mx-auto px-4 flex items-center justify-center min-h-screen">
            <div className="max-w-sm mx-auto space-y-6 text-center animate-fade-in">
              <h1 className="text-3xl md:text-4xl font-bold text-white leading-tight drop-shadow-[0_4px_12px_rgba(0,0,0,0.5)]">
                {HERO_CONTENT.title}
              </h1>
              <p className="text-base md:text-lg text-white/95 leading-relaxed font-medium drop-shadow-[0_2px_8px_rgba(0,0,0,0.4)]">
                {HERO_CONTENT.description}
              </p>
              <div className="flex flex-col gap-4 justify-center items-center pt-4">
                <button
                  onClick={scrollToForm}
                  className="group inline-flex items-center justify-center w-full px-8 py-3.5 bg-white text-[#1a4a1a] text-base font-bold rounded-xl shadow-2xl hover:shadow-[0_8px_30px_rgba(26,74,26,0.3)] hover:scale-105 transition-all duration-300 border-2 border-white/30 hover:border-white/50"
                >
                  {HERO_CONTENT.buttonText}
                  <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Desktop Layout - Elegant Gradient Overlay */}
        <div className="hidden md:flex h-screen mx-4 lg:mx-8 xl:mx-12 rounded-2xl overflow-hidden">
          {/* Full Background Image with Brightness Enhancement */}
          <div 
            className="absolute inset-0 z-0 brightness-110 contrast-105"
            style={{ 
              backgroundImage: `url("/uploads/hero-finance.jpg")`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />
          
          {/* Vibrant Gradient Overlay - Lighter and More Dynamic */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/40" />
          
          {/* Subtle Green Accent Overlay for Brand Consistency */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#1a4a1a]/10 via-transparent to-[#2d6a2d]/15" />
          
          {/* Text Content Overlay */}
          <div className="container relative z-10 mx-auto px-4 flex items-center justify-center">
            <div className="max-w-4xl mx-auto space-y-8 text-center animate-fade-in">
              <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight drop-shadow-[0_4px_20px_rgba(0,0,0,0.6)]">
                {HERO_CONTENT.title}
              </h1>
              <p className="text-xl md:text-2xl text-white/95 max-w-2xl mx-auto drop-shadow-[0_2px_12px_rgba(0,0,0,0.5)]">
                {HERO_CONTENT.description}
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
                <button
                  onClick={scrollToForm}
                  className="group inline-flex items-center justify-center px-10 py-4 bg-white text-[#1a4a1a] text-lg font-bold rounded-xl shadow-2xl hover:shadow-[0_8px_30px_rgba(26,74,26,0.3)] hover:scale-105 transition-all duration-300 border-2 border-white/30 hover:border-white/50"
                >
                  {HERO_CONTENT.buttonText}
                  <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="loan-form">
        <MultiStepForm />
      </section>

      {/* Finance Products Section */}
      <FinanceProducts />

      {/* Our Partners Section */}
      <OurPartners />

      {/* Unified Value Proposition Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a4a1a] mb-4 leading-tight">
              Why Choose HalalCred for Your Business Funding?
            </h2>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto">
              Making Islamic financing simple, transparent, and accessible for qualified businesses and nonprofits
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {/* Card 1: One-Stop Solution */}
            <div className="group bg-gradient-to-br from-emerald-50 to-green-50 rounded-xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 border border-emerald-100/50 hover:border-emerald-200">
              <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-green-600 rounded-xl flex items-center justify-center mb-6 transform group-hover:scale-110 transition-transform duration-300">
                <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-emerald-800 mb-3 group-hover:text-emerald-700 transition-colors">
                One-Stop Solution for finding riba-free capital
              </h3>
              <p className="text-emerald-700/80 leading-relaxed">
                Stop searching across multiple websites and institutions. <strong>Find all halal funding providers in one place</strong> - from community banks to CDFIs to Islamic financial institutions. Compare options side-by-side effortlessly.
              </p>
            </div>

            {/* Card 2: Business-Focused */}
            <div className="group bg-gradient-to-br from-cyan-50 to-teal-50 rounded-xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 border border-cyan-100/50 hover:border-cyan-200">
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-teal-600 rounded-xl flex items-center justify-center mb-6 transform group-hover:scale-110 transition-transform duration-300">
                <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-cyan-800 mb-3 group-hover:text-cyan-700 transition-colors">
                Designed for Businesses & Nonprofits
              </h3>
              <p className="text-cyan-700/80 leading-relaxed">
                Specifically built for <strong>Islamic community organizations and Muslim-owned businesses</strong> seeking growth capital. We understand your unique needs and connect you with capital providers supporting the next generation of Muslim-owned businesses.
              </p>
            </div>

            {/* Card 3: Application Success */}
            <div className="group bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 border border-blue-100/50 hover:border-blue-200">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center mb-6 transform group-hover:scale-110 transition-transform duration-300">
                <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-blue-800 mb-3 group-hover:text-blue-700 transition-colors">
                Application Success Kit
              </h3>
                <p className="text-blue-700/80 leading-relaxed">
                  Get <strong>proven templates, checklists, and strategies</strong> that have helped others secure funding. We provide resources and support throughout your financing journey to ensure your successful funding.
                </p>
            </div>

          </div>
        </div>
      </section>

      {/* Testimonials Section - Temporarily Commented Out
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#1a4a1a] mb-12 leading-tight">
            What Our Clients Say
          </h2>

          <div className="relative">
            <div className="overflow-hidden">
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {testimonials.map((testimonial, index) => (
                  <div
                    key={index}
                    className="w-full flex-shrink-0 px-4 md:px-8"
                  >
                    <div className="max-w-4xl mx-auto">
                      <blockquote className="text-center">
                        <p className="text-lg md:text-xl text-[#1a4a1a]/90 leading-relaxed mb-8">
                          {testimonial.quote}
                        </p>
                        <footer className="flex flex-col items-center">
                          <div className="w-16 h-16 mb-3 rounded-full overflow-hidden border-2 border-[#1a4a1a]/20">
                            <img
                              src={testimonial.image}
                              alt={testimonial.author}
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <cite className="not-italic">
                            <span className="block text-lg font-semibold text-[#1a4a1a]">
                              {testimonial.author}
                            </span>
                            <span className="text-sm text-[#1a4a1a]/80">
                              {testimonial.title}
                            </span>
                          </cite>
                        </footer>
                      </blockquote>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button
              className="absolute left-0 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white border border-[#1a4a1a]/20 shadow-sm text-[#1a4a1a]/60 hover:text-[#1a4a1a] hover:border-[#1a4a1a]/40 transition-all z-10"
              onClick={() => handlePrevSlide()}
              aria-label="Previous testimonial"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button
              className="absolute right-0 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white border border-[#1a4a1a]/20 shadow-sm text-[#1a4a1a]/60 hover:text-[#1a4a1a] hover:border-[#1a4a1a]/40 transition-all z-10"
              onClick={() => handleNextSlide()}
              aria-label="Next testimonial"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>

            <div className="flex justify-center gap-2 mt-8">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-all ${
                    currentSlide === index
                      ? 'bg-[#1a4a1a] scale-125'
                      : 'bg-[#1a4a1a]/20 hover:bg-[#1a4a1a]/40'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      */}

      {/*
      <section className="py-12 md:py-16 bg-slate-900 text-center">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 leading-tight text-white">Launching Soon!</h2>
          <p className="text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed text-slate-200">
            HalalCred is preparing to bring you trusted <strong className="text-white">Shariah-compliant financial solutions</strong>. 
            Our platform will offer verified <strong className="text-white">riba-free banking and financing options</strong>. 
            Be the first to experience our services - <strong className="text-white">join the waitlist</strong> now.
          </p>
          <Link 
            to="/signup" 
            className="inline-flex items-center justify-center w-full md:w-auto px-8 py-3 md:py-4 bg-[#1e3a8a] text-white text-base font-semibold rounded-lg shadow-md hover:shadow-lg hover:bg-[#1e3a8a]/90 transition-all"
          >
            Join the Waitlist
          </Link>
        </div>
      </section> */}


      {/* Newsletter Signup Section */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-cyan-50 via-teal-50 to-blue-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a4a1a] mb-4 leading-tight">
              Stay Updated with Islamic Financing Insights
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Get the latest updates on halal funding opportunities, Islamic financing news, and exclusive tips for Muslim-owned businesses.
            </p>
          </div>
          
          <div className="max-w-md mx-auto">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-cyan-100/50 p-8">
              <NewsletterSignup />
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a4a1a] mb-4 leading-tight">Get in Touch</h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">We're here to help with your Islamic financing needs</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-cyan-500 to-teal-600 rounded-2xl shadow-xl p-8 text-center group hover:shadow-2xl transition-all duration-300">
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white/30 transition-all duration-300">
                <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <a href="tel:+14253400980" className="block">
                <h3 className="text-xl font-bold text-white mb-2">Call Us</h3>
                <p className="text-lg text-white/90 font-semibold mb-1">+1-425-340-0980</p>
                <p className="text-white/80">Mon-Fri, 9am-5pm PST</p>
              </a>
            </div>

            <div className="bg-gradient-to-br from-emerald-500 to-green-600 rounded-2xl shadow-xl p-8 text-center group hover:shadow-2xl transition-all duration-300">
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white/30 transition-all duration-300">
                <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <a href="mailto:salaam@halalcred.com" className="block">
                <h3 className="text-xl font-bold text-white mb-2">Email Us</h3>
                <p className="text-lg text-white/90 font-semibold mb-1">salaam@halalcred.com</p>
                <p className="text-white/80">24hr Response Time</p>
              </a>
            </div>
          </div>
        </div>
      </section>
      <CookieConsent />
      
      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-6 right-6 p-3 rounded-full bg-[#1a4a1a] text-white shadow-lg hover:bg-[#1a4a1a]/90 transition-all transform hover:scale-105 ${
          showScrollTop ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
        aria-label="Scroll to top"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>

      {/* Add these styles at the end of your existing styles or in your global CSS file */}
      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        
        .infinite-scroll {
          animation: scroll 20s linear infinite;
        }
        
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }
      `}</style>
    </div>
  );
};

export default Home; 